import React from 'react';
import { Hammer, CheckCircle2, Clock, AlertTriangle, Factory, CalendarCheck } from 'lucide-react';
import { useT, fmtDate } from '../../salesI18n';

const STAGES = ['signed', 'ordered', 'ready', 'scheduled', 'installed'];

// Banner do vendedor: etapa do projeto vendido (contrato → fábrica → pronto → agendado → instalado), previsão e agendamento
export const ProjectStageBanner = ({ project }) => {
  const { t, lang } = useT();
  if (!project) return null;
  const stage = project.stage || (project.status === 'scheduled' ? 'scheduled' : 'ready');
  const idx = STAGES.indexOf(stage);
  const team = (project.scheduled_teams?.length ? project.scheduled_teams : [project.scheduled_team]).filter(Boolean).join(', ');
  const detail = project.late ? `${t.projectLate} · ${t.projectEta} ${fmtDate(project.eta, lang)}`
    : stage === 'scheduled' ? t.jobScheduled(team, fmtDate(project.scheduled_date, lang))
    : stage === 'installed' ? t.projectInstalledOn(fmtDate((project.installed_at || '').slice(0, 10), lang))
    : stage === 'ordered' ? [t.projectStages.ordered, project.order_number ? `${t.projectOrder} ${project.order_number}` : null, project.eta ? `${t.projectEta} ${fmtDate(project.eta, lang)}` : null].filter(Boolean).join(' · ')
    : t.projectStages[stage];
  const Icon = project.late ? AlertTriangle : stage === 'installed' ? CheckCircle2 : stage === 'scheduled' ? CalendarCheck : stage === 'ordered' ? Factory : stage === 'ready' ? Clock : Hammer;
  const tone = project.late ? 'border-red-200 bg-red-50/80' : stage === 'installed' ? 'border-emerald-200 bg-emerald-50/80' : 'border-teal-200 bg-teal-50/80';
  const iconTone = project.late ? 'bg-red-600' : stage === 'installed' ? 'bg-emerald-600' : stage === 'scheduled' ? 'bg-indigo-600' : 'bg-teal-600';
  return (
    <div className={`rounded-3xl border backdrop-blur-xl p-4 shadow-sm ${tone}`} data-testid="job-request-banner" data-stage={stage}>
      <div className="flex flex-wrap items-center gap-3">
        <span className={`h-10 w-10 rounded-2xl text-white flex items-center justify-center shrink-0 ${iconTone}`}><Icon className="h-5 w-5" /></span>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm text-slate-900">{t.projectTitle} · {project.contract_number}</p>
          <p className={`text-xs ${project.late ? 'text-red-800' : 'text-teal-800'}`} data-testid="job-request-status">{detail}</p>
        </div>
        {stage === 'ready' && <Clock className="h-5 w-5 text-amber-600 animate-pulse" />}
      </div>
      <ol className="mt-3 grid grid-cols-5 gap-1" data-testid="job-request-steps">
        {STAGES.map((s, i) => (
          <li key={s} className="flex flex-col items-center gap-1 min-w-0">
            <span className={`h-1.5 w-full rounded-full ${i < idx ? 'bg-emerald-500' : i === idx ? (project.late ? 'bg-red-500' : 'bg-teal-600') : 'bg-slate-200'}`} />
            <span className={`text-[10px] leading-tight text-center truncate w-full ${i === idx ? 'font-semibold text-slate-900' : 'text-slate-500'}`} data-testid={`job-request-step-${s}`}>{t.projectShort[s]}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default ProjectStageBanner;
